import { defineMessages } from 'react-intl';

export const messages: {
	team: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	team: {
		id: 'search_dialog_team',
		defaultMessage: 'Team',
		description: 'Label to indicate that the search result is a team',
	},
});
